import logo from './logo.svg';
import './App.css';
import ChatInterface from './chatbot';

function App() {
  return (
    <ChatInterface />
  );
}

export default App;
